import { Link } from 'react-router-dom';

const ServiziHero = () => {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a0f5d61c08b77a81a2894736916392fa.jpg"
          alt="NGP Renovatieproject Antwerpen – Diensten"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-xs font-medium text-white uppercase tracking-widest mb-6">
          Onze Diensten
        </span>
        <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
          RENOVATIE<br />
          <span className="text-amber-300">DIENSTEN</span>
        </h1>
        <p className="text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Professionele renovatiediensten in Antwerpen en omgeving. Van badkamer tot keuken, van appartement tot complete woningtransformatie — vakmanschap gegarandeerd.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/offerte"
            className="inline-flex items-center gap-2 bg-white text-gray-900 px-8 py-4 rounded-lg text-sm font-semibold hover:bg-amber-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            Gratis Offerte Aanvragen
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/photos"
            className="inline-flex items-center gap-2 border border-white/40 text-white px-8 py-4 rounded-lg text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Bekijk Ons Werk
            <i className="ri-image-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiziHero;
